import React from 'react';
import CloudTagSphere from './CloudTagSphere';
import SkillsContent from './SkillsContent';

const Skills = () => {
  return (
    <section id="skills" className="bg-light-blue dark:bg-light-black  pt-28">
      <div className=" max-w-screen-xl mx-auto px-2">
        <h3
          className="section-title relative text-4xl font-black underline underline-offset-[8px] decoration-orange mb-6 dark:text-white"
          style={{ fontFamily: " 'Dancing Script', cursive" }}
        >
          Skills
        </h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 p-4 md:p-0">
          {/*---- skill set ---- */}
          <SkillsContent />
          {/*---- cloud tag sphere ---- */}
          <CloudTagSphere />
        </div>
      </div>
    </section>
  );
};

export default Skills;
